import React from 'react';
import { ContactList } from '../ContactList';
import { IconTitle } from '../IconTitle';
import { StyledCallToAction } from './styles';

interface ICallToAction {
  className?: any;
  hookId?: any;
  icon?: any;
  title?: any;
}

export const CallToAction = ({
  className,
  hookId,
  icon,
  title,
}: ICallToAction) => {
  return (
    <StyledCallToAction className={className}>
      <IconTitle
        id={hookId}
        icon={icon}
        iconAlt={`Icon for ${title}`}
        title={title}
      />
      <div className="cta__content">
        <ContactList />
      </div>
    </StyledCallToAction>
  );
};
